const HIDE = "hidden";

const initNumFiles = async () => {
  const numFiles = document.getElementById("quantity");

  numFiles?.addEventListener("keyup", e => {
    // don't send form on Enter
    if (e.key === "Enter") {
      e.preventDefault();
    }
  });

  numFiles?.addEventListener("change", () => {
    updatePriceTotal();
  });
};

/**
 * calcDiscount returns the volume discount as a percentage
 * @param qt number of tracks commissioned
 */
const calcDiscount = (qt: number) => {
  if (qt >= 13) return 0.2;
  if (qt >= 9) return 0.15;
  if (qt >= 5) return 0.1;
  if (qt >= 3) return 0.05;
  return 0.0;
};

/**
 * calcNeededForDiscount returns the number of tracks needed
 * to reach the next volume discount tier
 * @param qt number of tracks commissioned
 */
const calcNeededForDiscount = (qt: number) => {
  if (qt >= 9) return 13 - qt;
  if (qt >= 5) return 9 - qt;
  if (qt >= 3) return 5 - qt;
  return 3 - qt;
};

const discountPopup = async (qt: number) => {
  const popup = document.getElementById("discount-popup");
  const hidePopup = async () => {
    popup?.classList.add(HIDE);
  };
  const showPopup = async (qt: number) => {
    if (popup === null) return;
    const tracksForNextDiscount = calcNeededForDiscount(qt);
    let str;
    if (tracksForNextDiscount > 1) {
      str = popup?.dataset.discountLabelP;
    } else {
      str = popup?.dataset.discountLabelS;
    }
    popup.innerHTML = str!;
    const tracksSpan = popup.querySelector("span#tracks-needed");
    if (tracksSpan !== null) {
      tracksSpan.innerHTML = String(tracksForNextDiscount);
    }
    const discountSpan = popup.querySelector("span#discount-value");
    if (discountSpan !== null) {
      discountSpan.innerHTML =
        String(calcDiscount(qt + tracksForNextDiscount) * 100) + "%";
    }
    popup.classList.remove(HIDE);
  };
  const f = () => {
    if (qt >= 13) {
      hidePopup();
    } else {
      showPopup(qt);
    }
  };
  f();
};

const updatePluralLabel = (
  numFiles: HTMLInputElement,
  totalNumTracksTdLabel: HTMLElement,
  isSet: boolean,
) => {
  if (numFiles.value === "1") {
    totalNumTracksTdLabel.innerText = String(
      isSet
        ? totalNumTracksTdLabel.dataset.labelSingularSet
        : totalNumTracksTdLabel.dataset.labelSingularTrack,
    );
  } else {
    totalNumTracksTdLabel.innerText = String(
      isSet
        ? totalNumTracksTdLabel.dataset.labelPluralSet
        : totalNumTracksTdLabel.dataset.labelPluralTrack,
    );
  }
};

const initUpdatePriceTotal = () => {
  const inputSet = document.querySelector(
    "input[name='is-set'][value='true']",
  ) as HTMLInputElement;
  const setServices = document.querySelectorAll("#set-services div.checkbox");
  const trackServices = document.querySelectorAll(
    "#track-services div.checkbox",
  );
  const numItemsLabel = document.getElementById("num-items");
  const numFiles = document.getElementById("quantity") as HTMLInputElement;
  const priceTotalUnit = document.getElementById("price-total-unit");
  const totalNumTracksTd = document.getElementById("total-num-tracks");
  const totalNumTracksTdLabel = document.getElementById(
    "total-num-tracks-label",
  );
  const pricePartialTd = document.getElementById("partial-total");
  const totalDiscountPct = document.getElementById("total-discount-percent");
  const totalDiscountVal = document.getElementById("total-discount-value");
  const priceTotalTd = document.getElementById("price-total");
  if (
    setServices === null ||
    trackServices === null ||
    numItemsLabel === null ||
    numFiles === null ||
    priceTotalUnit === null ||
    totalNumTracksTd === null ||
    totalNumTracksTdLabel === null ||
    pricePartialTd === null ||
    totalDiscountPct === null ||
    totalDiscountVal === null ||
    priceTotalTd === null
  )
    return () => {};
  return () => {
    let total = 0;
    const isSet = inputSet.checked;

    numItemsLabel.innerText = isSet
      ? numItemsLabel.dataset.sets!
      : numItemsLabel.dataset.tracks!;
    setServices.forEach(s =>
      isSet ? s.classList.remove(HIDE) : s.classList.add(HIDE),
    );
    trackServices.forEach(s =>
      isSet ? s.classList.add(HIDE) : s.classList.remove(HIDE),
    );

    if (numFiles.value === "" || numFiles.valueAsNumber < 1)
      numFiles.valueAsNumber = 1;
    discountPopup(numFiles.valueAsNumber);
    const checked: NodeListOf<HTMLInputElement> = document.querySelectorAll(
      `#${isSet ? "set" : "track"}-services .service-checkbox:checked`,
    );
    checked.forEach(c => {
      const priceStr = c.getAttribute("data-price") as string;
      const price = parseInt(priceStr, 10);
      total += price;
    });

    priceTotalUnit.innerText = String(total) + "€";

    totalNumTracksTd.innerText = numFiles.value;
    updatePluralLabel(numFiles, totalNumTracksTdLabel, isSet);

    const pricePartial = total * numFiles.valueAsNumber;
    pricePartialTd.innerText = String(pricePartial) + "€";

    const discount = calcDiscount(numFiles.valueAsNumber);
    totalDiscountPct.innerText = "−" + String(discount * 100) + "%";

    const totalDiscount = discount * pricePartial;
    totalDiscountVal.innerText = "−" + totalDiscount.toFixed(2) + "€";
    priceTotalTd.dataset.value = String(pricePartial - totalDiscount);
    priceTotalTd.innerText = (pricePartial - totalDiscount).toFixed(2) + "€";

    const btn = document.querySelector<HTMLInputElement>(
      "form#order-form input.btn",
    );
    if (btn === null) return;
    if (total > 0) {
      btn.disabled = false;
    } else {
      btn.disabled = true;
    }
  };
};

const initCheckBoxesRadios = async () => {
  const inputs = document.querySelectorAll(
    "input[type='checkbox'], input[type='radio']",
  );
  inputs.forEach(input => {
    input?.addEventListener("change", () => updatePriceTotal());
  });
};

const dimNavLogos = async (opacity: string) => {
  const navLogos: NodeListOf<HTMLImageElement> =
    document.querySelectorAll("nav div img");
  const dim = () => {
    navLogos.forEach(n => {
      n.style.opacity = opacity;
    });
  };
  dim();
};

const openGuestCheckoutModal = (open: boolean) => {
  const modal = document.getElementById("checkout-modal");
  const func = () => {
    if (open) {
      modal?.classList.remove(HIDE);
      modal?.classList.add("sm:flex");
      dimNavLogos("0.5");
    } else {
      modal?.classList.add(HIDE);
      modal?.classList.remove("sm:flex");
      dimNavLogos("1.0");
    }
  };
  func();
};

const highlightErrors = () => {
  const inputs = document.querySelectorAll<HTMLInputElement>("input");
  inputs.forEach(r => {
    if (!r.checkValidity()) {
      r.classList.add("error");
      const errorLabel = document.createElement("label");
      errorLabel.classList.add("error", "text-sm", "mb-2");
      errorLabel.innerText = r.validationMessage;
      r.insertAdjacentElement("afterend", errorLabel);
    }
  });
};

const removeErrors = () => {
  const errorLabels = document.querySelectorAll("label.error");
  errorLabels.forEach(e => e.remove());
};

const initBtns = async () => {
  const form: HTMLFormElement | null =
    document.querySelector("form#order-form");

  const checkoutBtn = document.getElementById("checkout-btn");
  const submitBtn = document.querySelector<HTMLInputElement>("#btn-submit");
  if (submitBtn === null) return;

  if (checkoutBtn !== null) {
    checkoutBtn.addEventListener("click", e => {
      e.preventDefault();
      const isValid = form?.checkValidity();
      if (isValid) {
        openGuestCheckoutModal(true);
        const guestEmailInput = document.querySelector<HTMLInputElement>(
          "input[name='guest-email']",
        );
        if (guestEmailInput === null) return;
        guestEmailInput.required = true;
        submitBtn.disabled = true;
        guestEmailInput.addEventListener(
          "input",
          () => (submitBtn.disabled = false),
        );
      } else {
        highlightErrors();
      }
    });
  }

  submitBtn.addEventListener("click", e => {
    e.preventDefault();
    removeErrors();
    const isValid = form?.checkValidity();
    if (isValid) {
      form?.submit();
    } else {
      highlightErrors();
    }
  });

  const cancelBtn = document.getElementById("btn-cancel");
  const cancelBtnX = document.getElementById("btn-cancel-x");
  [cancelBtn, cancelBtnX].forEach(c => {
    if (c !== null) {
      c.addEventListener("click", e => {
        e.preventDefault();
        openGuestCheckoutModal(false);
      });
    }
  });
};

const storeSession = () => {
  const inputs = document.querySelectorAll(
    "input[type='text'], input[type='number'], textarea, input[name='is-set']",
  );
  inputs.forEach(input => {
    input.addEventListener("change", async e => {
      const target = e.target as HTMLInputElement;
      const { name, value } = target;
      const res = await fetch("/api/session-cart/update", {
        method: "POST",
        credentials: "same-origin",
        redirect: "follow",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({ name, value }),
      });
    });
  });

  const subservices: NodeListOf<HTMLInputElement> = document.querySelectorAll(
    "input[name='track-services'],input[name='set-services']",
  );
  subservices.forEach(s => {
    s.addEventListener("change", async () => {
      const values = Array.from(subservices)
        .filter(f => f.checked)
        .map(m => m.value);
      const res = await fetch("/api/session-cart/update", {
        method: "POST",
        credentials: "same-origin",
        redirect: "follow",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({ name: "subservices", values }),
      });
    });
  });
};

export {
  initNumFiles,
  calcDiscount,
  calcNeededForDiscount,
  discountPopup,
  updatePriceTotal,
  initCheckBoxesRadios,
  dimNavLogos,
  openGuestCheckoutModal as openModal,
  initBtns,
};

let updatePriceTotal: () => void;

export default () => {
  const orderForm = document.getElementById("order-form");
  if (orderForm !== null) {
    // don't submit order if price is 0
    orderForm.addEventListener("submit", e => {
      const total = document.getElementById("price-total");
      if (total === null || total.dataset.value === undefined) return;
      const totalValue = parseInt(total.dataset.value);
      if (totalValue <= 0) e.preventDefault();
    });
    initCheckBoxesRadios();
    initNumFiles();
    updatePriceTotal = initUpdatePriceTotal();
    updatePriceTotal();
    initBtns();
    storeSession();
  }
};
